import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterUiService } from 'src/app/services/filter-ui.service';
import { SyncfusionService } from 'src/app/services/syncfusion.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { SyncFusionExternalFilterBaseComponent } from '../sync-fusion-external-filter-organism/sync-fusion-external-filter-organism.component';

@Component({
  selector: 'app-rm-procurement-report-organism',
  templateUrl: './rm-procurement-report-organism.component.html',
  styleUrls: ['./rm-procurement-report-organism.component.scss']
})
export class RmProcurementReportOrganismComponent extends SyncFusionExternalFilterBaseComponent{
  constructor(protected filterServices: FilterUiService, protected route: ActivatedRoute, protected syncfusion: SyncfusionService,
    protected settingsService: AppSettingService) {
    super(filterServices,route,syncfusion,settingsService);
    this.reloadPage();
  }

  

}
